import { loadScript } from './utils'

const wechatLibSrc = `https://res.wx.qq.com/open/js/jweixin-1.3.2.js`

class Mp {
  _loadWxForMp() {
    return new Promise(resolve => {
      console.log('promise')
      if (window.wx && window.wx.miniProgram) {
        resolve()
      } else {
        const loading =
          typeof this.$loading === 'function' ? this.$loading() : null
        loadScript(wechatLibSrc, () => {
          loading && loading.close()
          console.log('resolve')
          resolve()
        })
      }
    })
  }

  openWebView(options = {}) {
    let { isCurrentPageOpen, url, ...otherOptions } = options
    this._loadWxForMp().then(() => {
      if (typeof isCurrentPageOpen === 'undefined') {
        isCurrentPageOpen = 0
      }
      const event = isCurrentPageOpen === 0 ? 'navigateTo' : 'redirectTo'
      window.wx.miniProgram[event]({
        ...otherOptions,
        url: '../webView/webView?src=' + encodeURIComponent(url)
      })
    })
  }

  cancelWebView(options = {}) {
    this._loadWxForMp().then(() => {
      window.wx.miniProgram.navigateBack(options)
    })
  }
}

Mp.isMp = window.__wxjs_environment === 'miniprogram'

export default Mp



// WEBPACK FOOTER //
// ./src/libs/Mp.js